import React, { Component } from 'react';
import { Pager, Pagination } from 'react-bootstrap';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysisDocumentsTable.css';

export default class ListPagination extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            totalPages: Math.ceil(this.props.items.length / (this.props.itemsPerPage ? this.props.itemsPerPage : 15)),
            itemsToDisplay: this.getItemsToDisplay(this.props.items, 1)
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.items != prevProps.items) {
            this.setState({
                itemsToDisplay: this.getItemsToDisplay(this.props.items, this.state.activePage),
                totalPages: Math.ceil(this.props.items.length / this.props.itemsPerPage)
            });
        }
        if (this.state.activePage != prevState.activePage) {
            this.setState({ itemsToDisplay: this.getItemsToDisplay(this.props.items, this.state.activePage) });
        };
        if (this.props.itemsPerPage != prevProps.itemsPerPage) {
            this.setState({
                itemsToDisplay: this.getItemsToDisplay(this.props.items, this.state.activePage),
                totalPages: Math.ceil(this.props.items.length / this.props.itemsPerPage)
            });
        };
    }

    gotoPage = (page) => {
        page = Math.max(Math.min(page, this.state.totalPages), 0);
        this.setState({ activePage: page });

        if (this.props.onPageUpdate)
            this.props.onPageUpdate(page);
    }

    getItemsToDisplay = (items, activePage) => {
        if (items == null)
            return [];

        const itemsPerPage = this.props.itemsPerPage ? this.props.itemsPerPage : 15;
        const startIndex = (activePage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        return this.props.items.slice(startIndex, endIndex);
    }

    renderPagination() {
        const totalPages = this.state.totalPages;
        const activePage = this.state.activePage;

        let startPage = Math.max(1, activePage - 2);
        let endPage = Math.min(totalPages, activePage + 2);

        // Adjust startPage and endPage if there are not enough pages to show 5 pages
        if (endPage - startPage < 4) {
            if (activePage <= 3) {
                endPage = Math.min(startPage + 4, totalPages);
            } else {
                startPage = Math.max(endPage - 4, 1);
            }
        }

        const paginationItems = [];
        for (let page = startPage; page <= endPage; page++) {
            paginationItems.push(
                <Pagination.Item key={page} active={page === this.state.activePage} onClick={() => this.gotoPage(page)}>
                    {page}
                </Pagination.Item>
            );
        }

        return paginationItems;
    }

    render() {
        let showPagination = this.state.totalPages > 1;
        let showExpandedPagination = this.state.totalPages > 5;
        return (
            <div>
                {React.cloneElement(this.props.children, { items: this.state.itemsToDisplay })}
                <Pager>
                    {showExpandedPagination &&
                        <React.Fragment>
                            <Pagination.Prev onClick={() => this.gotoPage(this.state.activePage - 1)} />
                            <Pagination.Item onClick={() => this.gotoPage(1)}>{1}</Pagination.Item>
                            <Pagination.Ellipsis />
                        </React.Fragment>
                    }
                    {showPagination && this.renderPagination()}
                    {showExpandedPagination &&
                        <React.Fragment>
                            <Pagination.Ellipsis />
                            <Pagination.Item onClick={() => this.gotoPage(this.state.totalPages)}>{this.state.totalPages}</Pagination.Item>
                            <Pagination.Next onClick={() => this.gotoPage(this.state.activePage + 1)} />
                        </React.Fragment>
                    }
                </Pager>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Misc/ListPagination.js